import { useState, useEffect } from 'react';
import { UserTypeFilter } from './usePaginatedMediaData';
import { debugLogger } from '@/utils/debugLogger';

const STORAGE_KEY = 'admin_user_type_filter';
const DEFAULT_FILTER: UserTypeFilter = 'all';

export const useGlobalUserTypeFilter = () => {
  // Inicializar com valor do localStorage ou padrão
  const [userTypeFilter, setUserTypeFilterState] = useState<UserTypeFilter>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      const validFilters = ['all', 'sponsors', 'sponsored', 'free', 'standard', 'premium', 'active', 'pending', 'hidden', 'admins', 'test'];
      if (stored && validFilters.includes(stored)) {
        return stored as UserTypeFilter;
      }
    } catch (error) {
      debugLogger.warn('useGlobalUserTypeFilter', 'Failed to read from localStorage', error);
    }
    return DEFAULT_FILTER;
  });

  // Sincronizar com outras tabs
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        const newFilter = e.newValue as UserTypeFilter;
        const validFilters = ['all', 'sponsors', 'sponsored', 'free', 'standard', 'premium', 'active', 'pending', 'hidden', 'admins', 'test'];
        if (validFilters.includes(newFilter)) {
          setUserTypeFilterState(newFilter);
          debugLogger.debug('useGlobalUserTypeFilter', 'Filter synced from another tab', { newFilter });
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Setter que persiste no localStorage
  const setUserTypeFilter = (filter: UserTypeFilter) => {
    try {
      localStorage.setItem(STORAGE_KEY, filter);
      setUserTypeFilterState(filter);
      debugLogger.debug('useGlobalUserTypeFilter', 'Filter changed', { filter });
    } catch (error) {
      debugLogger.error('useGlobalUserTypeFilter', 'Failed to save to localStorage', error);
      setUserTypeFilterState(filter); // Ainda atualiza o estado mesmo se localStorage falhar
    }
  };

  const resetFilter = () => {
    setUserTypeFilter(DEFAULT_FILTER);
  };

  return {
    userTypeFilter,
    setUserTypeFilter,
    resetFilter
  };
};
